import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/modelViewerCursor.js';
import App from './App';

var pub = process.env.PUBLIC_URL || '';
document.documentElement.style.setProperty('--cursor-default', 'url("' + pub + '/cursors/default.svg") 1 1, auto');
document.documentElement.style.setProperty('--cursor-pointer', 'url("' + pub + '/cursors/pointer.svg") 9 0, pointer');
document.documentElement.style.setProperty('--cursor-grab', 'url("' + pub + '/cursors/grab.svg") 9 11, grab');
document.documentElement.style.setProperty('--cursor-grabbing', 'url("' + pub + '/cursors/grabbing.svg") 9 10, grabbing');
document.documentElement.style.setProperty('--cursor-writing', 'url("' + pub + '/cursors/writing.svg") 4 10, text');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
